import { forwardRef, useMemo } from 'react';
import TokenBase, { defaultTokenSize, isTokenInteractive } from './TokenBase.js';
import RemoveTokenButton from './_RemoveTokenButton.js';
import { parseToRgba, parseToHsla } from 'color2k';
import { useTheme } from '../ThemeProvider.js';
import TokenTextContainer from './_TokenTextContainer.js';
import classes from './IssueLabelToken.module.css.js';
import { clsx } from 'clsx';
import { jsxs, jsx } from 'react/jsx-runtime';

const IssueLabelToken = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    as,
    fillColor = '#999',
    onRemove,
    id,
    isSelected,
    text,
    size = defaultTokenSize,
    hideRemoveButton,
    href,
    onClick,
    className,
    ...rest
  } = props;
  const interactiveTokenProps = {
    as,
    href,
    onClick
  };
  const {
    resolvedColorScheme
  } = useTheme();
  const hasMultipleActionTargets = isTokenInteractive(props) && Boolean(onRemove) && !hideRemoveButton;
  const onRemoveClick = e => {
    e.stopPropagation();
    onRemove && onRemove();
  };
  const customProperties = useMemo(() => {
    const [r, g, b] = parseToRgba(fillColor);
    const [h, s, l] = parseToHsla(fillColor);
    return {
      '--label-r': String(r),
      '--label-g': String(g),
      '--label-b': String(b),
      '--label-h': String(Math.round(h)),
      '--label-s': String(Math.round(s * 100)),
      '--label-l': String(Math.round(l * 100))
    };
  }, [fillColor]);
  return /*#__PURE__*/jsxs(TokenBase, {
    onRemove: onRemove,
    id: id === null || id === void 0 ? void 0 : id.toString(),
    isSelected: isSelected,
    className: clsx(classes.IssueLabel, className),
    text: text,
    size: size,
    style: customProperties,
    "data-has-remove-button": !hideRemoveButton && !!onRemove,
    "data-selected": isSelected,
    "data-in-color-mode": resolvedColorScheme || 'light',
    ...(!hasMultipleActionTargets ? interactiveTokenProps : {}),
    ...rest,
    ref: forwardedRef,
    children: [/*#__PURE__*/jsx(TokenTextContainer, {
      ...(hasMultipleActionTargets ? interactiveTokenProps : {}),
      children: text
    }), !hideRemoveButton && onRemove ? /*#__PURE__*/jsx(RemoveTokenButton, {
      borderOffset: 1,
      onClick: onRemoveClick,
      size: size,
      "aria-hidden": hasMultipleActionTargets ? 'true' : 'false',
      isParentInteractive: isTokenInteractive(props),
      "data-has-multiple-action-targets": hasMultipleActionTargets,
      className: classes.RemoveButton
    }) : null]
  });
});
IssueLabelToken.displayName = 'IssueLabelToken';

export { IssueLabelToken as default };
